/**
 * flashToast – zeigt Bootstrap 5 Toasts aus AJAX-Responses.
 *
 * Nutzung:
 *   flashToast.handleResponse(response);
 *   flashToast.show('success', 'Gespeichert!');
 */

const SCRIPT_NAME = 'flashToasts.js';
const CONTAINER_ID = 'flashToastContainer';
const DEFAULT_DELAY = 5000;

/**
 * Zeigt einen einzelnen Toast an.
 *
 * @param {string} type  - success|info|warning|danger
 * @param {string} text  - Bereits übersetzter/escapeter Text
 * @param {number} [delay=5000] - Auto-Hide in ms
 */
export function show(type = 'info', text = '', delay = DEFAULT_DELAY) {
    const el = document.createElement('div');
    el.className = `toast align-items-center text-bg-${type} border-0`;
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');
    el.innerHTML = `<div class="d-flex">
        <div class="toast-body">${text}</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>`;

    document.getElementById(CONTAINER_ID).appendChild(el);

    const bsToast = new bootstrap.Toast(el, {autohide: true, delay});
    el.addEventListener('hidden.bs.toast', () => el.remove());
    bsToast.show();

    utils.consoleLog(SCRIPT_NAME, `Toast angezeigt: [${type}] ${text}`);
}

/**
 * Verarbeitet eine AJAX-Response mit toasts[]-Array.
 *
 * @param {object} response - JSON-Response vom Server
 * @param {Array}  [response.toasts] - [{ type, text, delay? }, ...]
 */
export function handleResponse(response) {
    if (!response?.toasts || !Array.isArray(response.toasts)) {
        return;
    }
    response.toasts.forEach(t => show(t.type, t.text, t.delay));
    utils.consoleLog(SCRIPT_NAME, `${response.toasts.length} Toast(s) aus Response verarbeitet.`);
}


/**
 * Verarbeitet die Toasts aus der Session mit data-bs-autohide.
 */
export function initializeToasts() {
    const toastElements = document.querySelectorAll('[data-bs-autohide]');
    toastElements.forEach(toastElement => {
        const toast = new bootstrap.Toast(toastElement);
        toast.show();
    });
}